export const FEATURE_COUNT_FOR_DISPLAY = 5;